import React, {useEffect} from 'react';
import Typography from '@mui/material/Typography';
import {CssBaseline, List, ListItem, ListItemText, Container, Button} from '@mui/material';
import {Link} from 'react-router-dom';
import {useCurrentUser} from '../../../../../store/auth';

interface UserRegistrationDTO {
  email: string;
  firstName: string;
  lastName: string;
  country: string;
  reviewerCode: string;
  mobile: string;
  consent: string;
}

export default function RegistrationReview() {
  const [data, setData] = React.useState<UserRegistrationDTO[]>([]);
  const [firstLoad, setLoad] = React.useState(true);
  const currentUser = useCurrentUser();

  async function handleLoadRequests() {
    const isid = currentUser.id;
    const response = await fetch('/api/v2/auth/registration/review/' + isid);
    if (response.status === 200) {
      const body = await response.json();
      setData(body);
      setLoad(false);
    }
  }

  useEffect(() => {
    if (firstLoad) {
      handleLoadRequests();
    }
  }, [firstLoad]);

  const handleResolveRequest = (email: string, approved: boolean) => {
    const sendResponse = async () => {
      const response = await fetch('/api/v2/auth/registration/review', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify([{email, approved}]),
      });
      if (response.status === 200) {
        await handleLoadRequests();
      }
    };
    sendResponse().then(() => alert('Access request reviewed'));
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <h1>Incoming user requests</h1>
      <List>
        {data.map((item) => (
          <ListItem key={item.email} alignItems="flex-start">
            <ListItemText
              primary={item.firstName + ' ' + item.lastName}
              secondary={
                <React.Fragment>
                  <Typography component="span" variant="body2">
                    {item.country} {item.email} {item.mobile}
                  </Typography>
                  <br />
                  Consent: {item.consent}
                </React.Fragment>
              }
            />
            <Button
              variant="contained"
              color="primary"
              sx={{m: 1, mb: 2}}
              onClick={() => handleResolveRequest(item.email, true)}
            >
              Accept
            </Button>
            <Button
              variant="contained"
              color="secondary"
              sx={{m: 1, mb: 2}}
              onClick={() => handleResolveRequest(item.email, false)}
            >
              Reject
            </Button>
          </ListItem>
        ))}
      </List>

      <Link to="/admin">
        <Button fullWidth variant="outlined" color="primary" sx={{m: 1, mb: 2}}>
          Back
        </Button>
      </Link>
    </Container>
  );
}
